/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CreateAssetOptions, CreateAssetResponses } from '../types/CreateAsset'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create an asset
 * {@link /v1/assets}
 */
export function createAsset<ThrowOnError extends boolean = true>(
  options: Options<CreateAssetOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateAssetResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/assets',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateAssetResponses, ThrowOnError>>,
  )
}
